function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "user"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 243.18,
  cy: 132.63,
  r: 132.63
}), /*#__PURE__*/React.createElement("path", {
  d: "M412.41,340.45c-45.36-24.62-105.36-38.18-168.95-38.18s-123.59,13.56-168.95,38.18C26.46,366.53,0,402.16,0,440.79v.57c.22,32.12,26.75,58.26,59.13,58.26H427.79c32.38,0,58.91-26.13,59.13-58.25v-.58c0-38.62-26.46-74.26-74.51-100.34Z"
}));

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486.92 499.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.dc228836.svg";
export { ForwardRef as ReactComponent };